export default function convertToBytes(
  size: number,
  unit: "KB" | "MB" | "GB" | "TB"
) {
  switch (unit) {
    case "KB":
      return size * 1024;
    case "MB":
      return size * 1024 * 1024;
    case "GB":
      return size * 1024 * 1024 * 1024;
    case "TB":
      return size * 1024 * 1024 * 1024 * 1024;
    default:
      return size;
  }
}
